import React from "react";
import { Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  QUICK_FILTERS,
  replaceQuickFilters,
  getQuickFilterDotColor,
} from "../../../../redux/slices/leadSlice";
import { leadStatus } from "../engagementActivity";

const QuickFiltersContent = ({
  restrictRemoveDefaultFilter = false,
  variables,
  setVariables,
  scrollListToTop,
  clearUrl,
  search = "",
  onFilterChange,
  onClear,
}) => {
  const dispatch = useDispatch();
  const selectedQuickFilters = useSelector(state => state.lead.filters.quickFilters);

  const filteredStatus = leadStatus.filter(item =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  // MY_CONVERSATIONS is locked (and re-applied by `onClear`) under the
  // restrict-remove-default permission, so it isn't something the user can
  // clear. With only that one selected there is nothing left to remove.
  const removableFilterCount = restrictRemoveDefaultFilter
    ? (selectedQuickFilters || []).filter(id => id !== QUICK_FILTERS.MY_CONVERSATIONS).length
    : (selectedQuickFilters || []).length;

  const handleToggle = filterId => {
    let newFilters;
    if (selectedQuickFilters.includes(filterId)) {
      if (restrictRemoveDefaultFilter && filterId === QUICK_FILTERS.MY_CONVERSATIONS) {
        return;
      }
      newFilters = selectedQuickFilters.filter(f => f !== filterId);
    } else {
      newFilters = [...selectedQuickFilters, filterId];
    }

    if (restrictRemoveDefaultFilter && !newFilters.includes(QUICK_FILTERS.MY_CONVERSATIONS)) {
      newFilters = [QUICK_FILTERS.MY_CONVERSATIONS, ...newFilters];
    }

    setVariables?.({ ...variables, page: 1 });
    dispatch(replaceQuickFilters(newFilters));
    scrollListToTop?.();
    clearUrl?.();
    onFilterChange?.();
  };

  return (
    <div className="flex flex-col px-3 py-2">
      {onClear && selectedQuickFilters.length > 0 && (
        <div className="flex justify-end mb-1">
          {/* Plain span like the panel's "Clear all" — antd's disabled link
              color is overridden by the app's link styling, so the state is
              expressed with explicit classes instead. */}
          <span
            className={`text-sm font-normal ${
              removableFilterCount > 0
                ? "text-twLinkColor cursor-pointer"
                : "text-grey-300 cursor-not-allowed"
            }`}
            onClick={removableFilterCount > 0 ? onClear : undefined}
          >
            Clear
          </span>
        </div>
      )}
      {filteredStatus.map(item => {
        const isLocked = restrictRemoveDefaultFilter && item.id === QUICK_FILTERS.MY_CONVERSATIONS;
        return (
          <div
            key={item.id}
            className={`flex items-center gap-2 py-2 px-1 rounded ${
              isLocked ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:bg-gray-50"
            }`}
            onClick={() => !isLocked && handleToggle(item.id)}
          >
            <Checkbox checked={selectedQuickFilters.includes(item.id)} disabled={isLocked} />
            <span
              className="w-2 h-2 rounded-full inline-block"
              style={{ backgroundColor: getQuickFilterDotColor(item.id) }}
            />
            <span className="text-sm text-black-88">{item.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default QuickFiltersContent;
